import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import css from 'styles/components/account/paymentFormAddressCard.scss';

const PaymentFormAddressCard = ({ address, isBillingAddress, onAddressChange }, { testId }) => {
  const { addressId, name: { fullName }, mailingAddress } = address;
  const { addressLine1, addressLine2, city, stateOrRegion, postalCode, countryName } = mailingAddress;

  return (
    <div className={cn(css.card, css.radio, { [css.selected]: isBillingAddress })}>
      <input
        type="radio"
        id={`address${addressId}`}
        name="addressId"
        defaultChecked={isBillingAddress}
        defaultValue={addressId}
        onChange={onAddressChange}
        data-test-id={testId('radioAddressSelector')}/>
      <label htmlFor={`address${addressId}`} className={css.addressLabel}>
        <span data-test-id={testId('shippingAddressCardName')}>{fullName}</span>
        <span data-test-id={testId('shippingAddressCardAddress1')}>{addressLine1}</span>
        <span data-test-id={testId('shippingAddressCardAddress2')}>{addressLine2}</span>
        <span data-test-id={testId('shippingAddressCardCityStateZip')}>{city}, {stateOrRegion} {postalCode}</span>
        <span data-test-id={testId('shippingAddressCardCountry')}>{countryName}</span>
      </label>
    </div>
  );
};

PaymentFormAddressCard.contextTypes = {
  testId: PropTypes.func
};

PaymentFormAddressCard.propTypes = {
  address: PropTypes.object.isRequired,
  isBillingAddress: PropTypes.bool.isRequired,
  onAddressChange: PropTypes.func.isRequired
};

export default PaymentFormAddressCard;
